import { Routes } from '@angular/router';
import { permisoGuard } from '../core/auth/permiso.guard';
import { Permiso } from '../core/auth/permisos';

export const serviciosRoutes: Routes = [
  {
    path: 'servicios',
    canActivate: [permisoGuard],
    data: { permiso: [Permiso.SERVICIOS_VER, Permiso.SERVICIOS_GESTIONAR] },
    loadComponent: () => import('./pages/servicios/servicios.page').then((m) => m.ServiciosPage),
    title: 'SiLabVet | Servicios',
  },
  {
    path: 'servicios/nuevo',
    canActivate: [permisoGuard],
    data: { permiso: Permiso.SERVICIOS_GESTIONAR },
    loadComponent: () =>
      import('./pages/servicio-form/servicio-form.page').then((m) => m.ServicioFormPage),
    title: 'SiLabVet | Nuevo servicio',
  },
  {
    path: 'servicios/:id/editar',
    canActivate: [permisoGuard],
    data: { permiso: Permiso.SERVICIOS_GESTIONAR },
    loadComponent: () =>
      import('./pages/servicio-form/servicio-form.page').then((m) => m.ServicioFormPage),
    title: 'SiLabVet | Editar servicio',
  },
  {
    path: 'excepciones-pago',
    canActivate: [permisoGuard],
    data: { permiso: Permiso.EXCEPCIONES_VER },
    loadComponent: () => import('./pages/excepciones/excepciones.page').then((m) => m.ExcepcionesPage),
    title: 'SiLabVet | Solicitudes de pago',
  },
];
